"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = void 0;

var _react = require("react");

var _createContext = /*#__PURE__*/(0, _react.createContext)(false),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Provider = Provider;
exports.Consumer = Consumer;